import { md5 } from '@noble/hashes/legacy'
import { format } from 'date-fns'
import type { Listing, Organization, User } from '~/models'

const crsCommands = [
  'login', // simple search, default
  'advsearch', // advanced search
  'cmp', // comparable
  'dem', // demographics
  'map', // parcel map
  'mapsearch', // map search
  'settings', // profiles & settings
  'rpt', // property report
  'prospect', // prospecting
  'search', // search results
] as const

type CRSCommand = (typeof crsCommands)[number]

const date = format(new Date(), 'yyyyMMdd')
const signup = '20250527'
const sc = 'REsimplifi'

function createACCode(organization: string): string {
  const name = organization.toUpperCase()

  return `AC${date}${name}_${signup}_${sc}`
}

function hash(value: string): string {
  const encoder = new TextEncoder()
  const data = encoder.encode(value)
  const hashed = md5(data)

  return Array.from(hashed)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

export function createSignedCRSLink({
  organization,
  user,
}: {
  organization: Organization['name']
  user: User['tid']
}) {
  const url = new URL(`https://${organization}.crsdata.com/login/mls/`)
  const ac = hash(createACCode(organization))

  url.searchParams.set('sc', sc)
  url.searchParams.set('mls', organization)
  url.searchParams.set('user', user)
  url.searchParams.set('ac', ac)

  return url
}

export function getCRSListingLink({
  cmd,
  listing,
  url,
}: {
  cmd?: CRSCommand
  listing: Listing
  url: URL
}) {
  if (listing.property.county) {
    url.searchParams.set('county', listing.property.county)
  }

  if (listing.property.stateAbbr) {
    url.searchParams.set('state', listing.property.stateAbbr)
  }

  if (listing.property.parcelApn) {
    url.searchParams.set('pid', listing.property.parcelApn)
  } else if (listing.property.address) {
    // Undocumented parameter for full address search
    url.searchParams.set('addnoandname', listing.property.address)
  }

  if (cmd) {
    url.searchParams.set('cmd', cmd)
  }

  return url
}
